module.exports = "/_next/static/images/ExtensibleDocumentation@2x-bc692ea630912b9ae04b1211cd68af07.webp";